<template>
  <div class="about-page">

    <!-- Intro / Slider Section -->
    <section class="about-intro">
      <!-- Background Pattern -->
      <div class="about-intro__pattern"></div>
      <div class="about-intro__overlay"></div>

      <!-- Floating decorative elements -->
      <div class="about-intro__float about-intro__float--1"></div>
      <div class="about-intro__float about-intro__float--2"></div>
      <div class="about-intro__float about-intro__float--3"></div>

      <div class="about-shell">

        <!-- Two-column intro content -->
        <div class="about-intro__grid">
          <!-- Left: text + feature list -->
          <div class="about-intro__left">
            <h3 class="about-intro__heading">{{ $t('about.headerInvestissement') }}</h3>
            <p class="about-intro__lead">{{ $t('about.contentInvestissement') }}</p>

            <div class="about-features">
              <div
                v-for="feature in features"
                :key="feature.id"
                class="about-feature pages__about--card-hover"
              >
                <div class="about-feature__icon">
                  <i :class="feature.icon"></i>
                </div>
                <div class="about-feature__body">
                  <h4 class="about-feature__title">{{ feature.title }}</h4>
                  <p class="about-feature__desc">{{ feature.description }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Right: performance chart panel -->
          <div class="about-intro__right">
            <div class="about-perf-panel">
              <div class="about-perf-panel__inner">
                <div class="about-perf-panel__header">
                  <h4 class="about-perf-panel__title">{{ $t('about.performanceInvestissement') }}</h4>
                  <span class="about-perf-panel__badge">+36%</span>
                </div>

                <div class="about-perf-panel__chart">
                  <div
                    v-for="(height, index) in chartData"
                    :key="index"
                    class="about-perf-panel__bar"
                    :style="{ height: height + '%' }"
                  ></div>
                </div>

                <div class="about-perf-panel__labels">
                  <span>2022</span>
                  <span>2023</span>
                  <span>2024</span>
                  <span>2025</span>
                  <span>2026</span>
                </div>
              </div>

              <div class="about-perf-panel__brokers">
                <div class="about-perf-panel__broker">
                  <span class="about-perf-panel__broker-name about-perf-panel__broker-name--tvsi">TVSI</span>
                </div>
                <div class="about-perf-panel__broker">
                  <span class="about-perf-panel__broker-name about-perf-panel__broker-name--exness">Exness</span>
                </div>
                <div class="about-perf-panel__broker">
                  <span class="about-perf-panel__broker-name about-perf-panel__broker-name--vantage">Vantage</span>
                </div>
                <div class="about-perf-panel__broker">
                  <span class="about-perf-panel__broker-name about-perf-panel__broker-name--puprime">PU Prime</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Dark CTA banner -->
        <div class="about-env-banner">
          <div class="about-env-banner__inner">
            <h3 class="about-env-banner__title">{{ $t('about.environmentInvestissement') }}</h3>
            <p class="about-env-banner__desc">{{ $t('about.environmentInvestissementContent') }}</p>

            <div class="about-env-banner__tags">
              <div class="about-env-banner__tag">
                <span>{{ $t('about.partagerVN') }}</span>
              </div>
              <div class="about-env-banner__tag">
                <span>{{ $t('about.cfd') }}</span>
              </div>
              <div class="about-env-banner__tag">
                <span>{{ $t('about.copyTrade') }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>

    <productOverview></productOverview>
    <treeTvsi></treeTvsi>
    <treeExness></treeExness>

  </div>
</template>

<script src="./about.js"></script>
<style src="./about.scss" lang="scss"></style>
